<script>
	export default {
		name: 'GpuExecuter',
		methods: {
			gpuRun(loopCount) {
				const self_ = this;

				const kernel_ = self_.gpu.createKernel(loopCount => {
					let count_ = 0;
					for (let j = 0; j < loopCount; j++) {
						count_++;
					}
					return count_
				}, { output: [1], loopMaxIterations: 1000 })

				return kernel_(loopCount)
			}
		}
	}
</script>